import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { PlanEditGesture } from '@core/models/plan-edit-gesture.model';
import { WatchPatchEvent } from '@core/models/plan-edit.model';

import { PlanEditReloadSnapshot } from './plan-edit-reload';
import { InFlightGesture } from './plan-edit.state';

export const PlanEditSessionActions = createActionGroup({
  source: 'PlanEditSession',
  events: {
    Opened: props<{ sessionId: string; revision: number; resumable: boolean }>(),
    Resumed: props<{ sessionId: string } & WatchPatchEvent>(),
    /** `mintedRouteUids`: temporary route key → the uid DL minted; empty unless the batch opened one. */
    Applied: props<
      {
        appliedClientSeq: number;
        mintedRouteUids: Record<string, string>;
      } & WatchPatchEvent
    >(),
    /** A recompute settles the session, so the reducer reads it as `recomputePending: false`. */
    Recomputed: props<Omit<WatchPatchEvent, 'recomputePending'>>(),
    /** `errorMessage` is DL's or GBE's own explanation, empty when the frame carried none. */
    Rejected: props<{
      clientSeq: number | null;
      intentIndex: number | null;
      errorCode: string;
      errorMessage: string;
      details: Record<string, unknown>;
    }>(),
    Saved: props<{ planDataRevision: string }>(),
    'Save Rejected': props<{
      clientSeq: number;
      errorCode: string;
      errorMessage: string;
      details: Record<string, unknown>;
    }>(),
    Closed: props<{ reason: string }>(),
    'Connection Lost': emptyProps(),
    'Edit Requested': props<{ planId: string; paramId: number }>(),
    'Gesture Requested': props<{ gesture: PlanEditGesture }>(),
    'Gesture Sent': props<InFlightGesture>(),
    'Gesture Refused Locally': props<{ messageKey: string }>(),
    'Undo Requested': emptyProps(),
    'Redo Requested': emptyProps(),
    'Undo Sent': props<{
      clientSeq: number;
      touchedRouteUids: string[];
      direction: 'undo' | 'redo';
    }>(),
    'Save Requested': emptyProps(),
    'Save Sent': props<{ clientSeq: number }>(),
    'Discard Requested': emptyProps(),
    'Done Requested': emptyProps(),
    'Close Sent': emptyProps(),
    'Handed Over': props<{ planId: string }>(),
    'Handed Back': props<{ planId: string }>(),
    /** A session this tab stashed when its page went away, to be resumed. */
    'Restored After Reload': props<{ snapshot: PlanEditReloadSnapshot }>()
  }
});
